import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { ModalController, AlertController, NavParams } from '@ionic/angular';
import { ValidationService } from '../../services/validation.service';
import { UnfocusElementService } from '../../services/unfocus-element.service';
import { ApiPaymentService } from '../../api-services/payment.api.service';
import { BillingAddress } from '../../models/payment/PaymentRequest';
import { countryList } from '../../../assets/content/countries';
import { euCountryList } from '../../../assets/content/eucountries';
import { usStateList } from '../../../assets/content/usstates';
import { PaymentResponse } from '../../models/payment/PaymentResponse';
import { FormGroup, FormBuilder, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { CustomerService } from '../../services/customer.service';
import { CryptoService } from '../../services/crypto.service';
import { MessagesService } from 'src/app/services/messages.service';
import { Discount } from 'src/app/models/payment/Discount';

declare var Worldpay: any;

@Component({
  selector: 'app-payment-modal',
  templateUrl: './payment-modal.component.html',
  styleUrls: ['./payment-modal.component.scss'],
})
export class PaymentModalComponent implements OnInit {

  @ViewChild('paymentForm') form;

  // SANDBOX KEY;
  readonly worldpayClientKey = 'T_C_b4a16824-d78c-4b01-aa7f-0316554bc009';

  // LIVE KEY;
  // readonly worldpayClientKey = ''; // To be received from accounts...

  public currencyPrefix: string = "";
  public customerId: number = 0;
  public productId: number = 0;
  public address1: string = "";
  public address2: string = "";
  public address3: string = "";
  public city: string = "";
  public county: string = "";
  public country: string = "";
  public postcode: string = "";
  public telephone: string = "";
  public vatNumber: string = "";
  public einNumber: string = "";
  public stage: string = "Country";
  public complete: boolean = false;
  public selCountry: string = "";
  public countryList = countryList;
  public euCountryList = euCountryList;
  public usStateList = usStateList;
  public selCountryIsEu: boolean = false;
  public selCountryIsUs: boolean = false;
  public price: number = 0;
  public paymentStarted: boolean = false;
  public pausePayment: boolean = false;

  public discountCode: string = "";
  public discountErrorMessage: string = "";
  public addedDiscounts: Discount[] = [];
  public discounts: Discount[] = [
    {
      productId: 1,
      discountCode: "3MFree",
      discountDescription: "15 months, for the price of 12 months."
    }
  ];

  constructor(
    public modalController: ModalController,
    public alertController: AlertController,
    public validationService: ValidationService,
    public unfocusService: UnfocusElementService,
    public apiPaymentService: ApiPaymentService,
    public navParams: NavParams,
    public formBuilder: FormBuilder,
    private changeDetectorRef: ChangeDetectorRef,
    public customerService: CustomerService,
    public cryptoService: CryptoService,
    public messageService: MessagesService
  ) {
    this.customerId = this.navParams.get("customerId");
    this.productId = this.navParams.get("productId");
    this.pausePayment = this.navParams.get("pausePayment");

    this.address1 = this.cryptoService.decryptData(localStorage.getItem("billing_address1"));
    this.address2 = this.cryptoService.decryptData(localStorage.getItem("billing_address2"));
    this.address3 = this.cryptoService.decryptData(localStorage.getItem("billing_address3"));
    this.city = this.cryptoService.decryptData(localStorage.getItem("billing_city"));
    this.county = this.cryptoService.decryptData(localStorage.getItem("billing_county"));
    this.postcode = this.cryptoService.decryptData(localStorage.getItem("billing_postcode"));
    this.country = this.cryptoService.decryptData(localStorage.getItem("billing_country"));
    this.telephone = this.cryptoService.decryptData(localStorage.getItem("billing_telephone"));
    this.einNumber = this.cryptoService.decryptData(localStorage.getItem("billing_einNumber"));
    this.vatNumber = this.cryptoService.decryptData(localStorage.getItem("billing_vatNumber"));

    this.stage = "Country";
    this.paymentStarted = false;
    this.getCountry();
  }

  ngOnInit() {
    this.clearForm();
    this.stage = "Country";
  }

  clearForm() {
    this.country = this.customerService.customer.country;
    this.complete = false;
  }

  checkField(flag, field, message) {
    if (flag)
      return flag;
    else {
      flag = (field.length == 0 || field == null || field == undefined || field.toString() == "null");

      if (flag) {
        this.alertController.create({
          header: "Address Details Incorrect",
          message: message,
          buttons: [
            {
              text: 'Ok',
              handler: () => {
                this.alertController.dismiss();
              }
            }
          ]
        }).then((a) => {
          a.present();
        });
      }

      return flag;
    }
  }

  saveCountry() {
    localStorage.setItem("billing_country", this.cryptoService.encryptData(this.country));
    this.stage = "Address";
    this.getCountry();
    this.changeDetectorRef.detectChanges();
  }

  saveAddress() {
    var flag = false;

    flag = this.checkField(flag, this.address1, "Address field not entered correctly, please try again.");
    flag = this.checkField(flag, this.city, "City field not entered correctly, please try again.");
    flag = this.checkField(flag, this.county, "County field not entered correctly, please try again.");
    flag = this.checkField(flag, this.postcode, "Postcode field not entered correctly, please try again.");
    flag = this.checkField(flag, this.telephone, "Telephone field not entered correctly, please try again.");

    if (!flag) {
      this.stage = "Discounts";
    }
  }

  proceed(){
    this.complete = true;

    localStorage.setItem("billing_address1", this.cryptoService.encryptData(this.address1));
    localStorage.setItem("billing_address2", this.cryptoService.encryptData(this.address2));
    localStorage.setItem("billing_address3", this.cryptoService.encryptData(this.address3));
    localStorage.setItem("billing_city", this.cryptoService.encryptData(this.city));
    localStorage.setItem("billing_county", this.cryptoService.encryptData(this.county));
    localStorage.setItem("billing_postcode", this.cryptoService.encryptData(this.postcode));
    localStorage.setItem("billing_telephone", this.cryptoService.encryptData(this.telephone));
    localStorage.setItem("billing_einNumber", this.cryptoService.encryptData(this.einNumber));
    localStorage.setItem("billing_vatNumber", this.cryptoService.encryptData(this.vatNumber));

    let address: BillingAddress = {
      address1: this.address1,
      address2: this.address2,
      address3: this.address3,
      city: this.city,
      country: this.country,
      county: this.county,
      postcode: this.postcode,
      telephone: this.telephone,
      vatNumber: this.vatNumber,
      einNumber: this.einNumber,
      discounts: this.addedDiscounts
    };

    this.apiPaymentService.getPrice(this.productId, address).subscribe(resp => {
      this.price = resp;
      this.currencyPrefix = this.getCurrency();

      if (!this.pausePayment){
        setTimeout(() => {
          Worldpay.useTemplateForm({
            'clientKey': this.worldpayClientKey,
            'form': this.form.nativeElement,
            'paymentSection': 'paymentSection',
            'display': 'inline',
            'type': 'card',
            'callback': this.worldpayCallback
          });
        }, 1000);
      } else {
        setTimeout(() => {
          this.paymentStarted = true;
          this.messageService.presentLoadingWindow("Processing Payment...");

          // Process payment through the API;
          this.apiPaymentService.processBPPayment(this.customerId, this.productId, address).subscribe(resp => {
            this.messageService.loadingWindow.dismiss();
            this.paymentStarted = false;
            this.success();
          });
        }, 2000);
      }
    });

  }

  worldpayCallback = (response): void => {
    if (response.error != null && response.error != undefined) {
      this.handleError(response.error.object);
    } else {
      if (!this.paymentStarted) {
        this.paymentStarted = true;
        this.messageService.presentLoadingWindow("Processing Payment...");
        let address: BillingAddress = {
          address1: this.address1,
          address2: this.address2,
          address3: this.address3,
          city: this.city,
          country: this.country,
          county: this.county,
          postcode: this.postcode,
          telephone: this.telephone,
          vatNumber: this.vatNumber,
          einNumber: this.einNumber,
          discounts: this.addedDiscounts
        };

        // Process payment through the API;
        this.apiPaymentService.processPayment(this.customerId, this.productId, response.token, address).subscribe(resp => {
          this.messageService.loadingWindow.dismiss();
          this.paymentStarted = false;
          if (resp.success)
            this.success();
          else
            this.failure(resp);
        });
      }
    }
  }

  getCurrency() {
    this.getCountry();
    if (this.country == "United States") {
      return "$";
    } else if (this.country == "United Kingdom" || this.country == "Scotland" || this.country == "England" || this.country == "Northern Ireland" || this.country == "Wales") {
      return "£";
    } else if (this.selCountryIsEu) {
      return "€";
    } else {
      return "$";
    }
  }

  getCountry() {
    if (this.country == "United States") {
      this.selCountryIsEu = false;
      this.selCountryIsUs = true;
    } else if (this.countryInEu()) {
      this.setEuCountry(true);
    } else {
      this.setEuCountry(false);
    }
  }

  countryInEu() {
    var inEu = this.euCountryList.filter(x => x == this.country).length > 0;
    this.setEuCountry(inEu);
    return inEu;
  }

  setEuCountry(v: boolean) {
    this.selCountryIsUs = false;
    this.selCountryIsEu = v;
  }

  async failure(resp: PaymentResponse) {
    this.alertController.create({
      header: "Payment Failed",
      message: 'Your payment was unsuccessful, please try again.',
      buttons: [
        {
          text: 'Ok',
          handler: () => {
            this.modalController.dismiss();
            this.alertController.dismiss();
          }
        }
      ]
    }).then((a) => {
      a.present();
    });
  }

  async success() {
    this.alertController.create({
      header: "Payment Successful",
      message: 'Your account has been successfully upgraded.',
      buttons: [
        {
          text: 'Ok',
          handler: () => {
            this.modalController.dismiss();
            this.alertController.dismiss();
            window.location.reload();
          }
        }
      ]
    }).then((a) => {
      a.present();
    });
  }

  handleError(err) {
    console.error(err);
  }

  closeModal() {
    this.modalController.dismiss();
  }

  addDiscount(){
    let addedDiscount = this.addedDiscounts.find(d => d.productId == this.productId && d.discountCode == this.discountCode);
    if(addedDiscount){
      this.discountCode = "";
      this.discountErrorMessage = "";
      return;
    }

    let discount = this.discounts.find(d => d.productId == this.productId && d.discountCode == this.discountCode);
    if(discount){
      this.addedDiscounts.push(discount);
      this.discountCode = "";
      this.discountErrorMessage = "";
    }else{
      this.discountCode = "";
      this.discountErrorMessage = "Invalid voucher code!"
    }
  }

  deleteDiscount(index: number){
    this.addedDiscounts.splice(index, 1);
  }

  saveDiscounts(){
    this.stage = "";
    this.complete = true;
    this.proceed();
  }
}